/**
 * Runtime config. Reads Vite env vars (must be prefixed VITE_ to be
 * exposed to the browser). The cmedev defaults match the values in
 * cme-wiki Auth0_provisioned_entities.md.
 */

function envVar(name: string, fallback?: string): string {
  const value = import.meta.env[name] as string | undefined;
  if (value && value.length > 0) return value;
  if (fallback !== undefined) return fallback;
  throw new Error(`Missing required env var: ${name}`);
}

export const config = {
  auth0Domain: envVar("VITE_AUTH0_DOMAIN", "cmedev.eu.auth0.com"),
  auth0ClientId: envVar("VITE_AUTH0_CLIENT_ID", "KV6ivCgB8whPrZLrQaaGvhyz46v0v5LO"),
  auth0Audience: envVar("VITE_AUTH0_AUDIENCE", "https://cme-studio.app/api"),
  // No organization here, by design (ACC-4). Auth0 resolves it from the signed-in
  // person's membership; a build-time org would pin every user of a deployment to
  // one customer. The comment that used to sit on this line described the deleted
  // VITE_AUTH0_ORGANIZATION and had drifted onto the audience below it.
  wikiLLMAudience: envVar("VITE_WIKI_LLM_AUDIENCE", "https://wiki-llm.cme-studio.app/api"),
  cmeinsightApiUrl: envVar("VITE_CMEINSIGHT_API_URL", "http://localhost:8000"),
  wikiLLMApiUrl: envVar("VITE_WIKI_LLM_API_URL", "http://localhost:8001"),
};
